module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "p1h3"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img12",
      "src": "images/img12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Privates of Company D, Twenty-fifth Infantry, at Fort Custer, Montana Territory. The man at lower right wears Grand Army of the Republic membership badges, besides his membership badge in the Regular Army and Navy Union. The man standing at right likewise wears his RA&NU badge, and also marksman and sharpshooter qualification pins. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Courtesy of James B. Dahlquist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31ee894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_p13.vue
// module id = 138
// module chunks = 0